import { Component, OnInit } from '@angular/core';

import { DataService } from '../../../../../../../infrastructure/services/base/config/data.service';

@Component({
  selector: 'create-booking',
  templateUrl: './create.html',
  providers: [DataService],

})
export class CreateBookingComponent implements OnInit {
  Title: string = 'Loading Bay Booking';
  TitleDesc: string = '';
  BreadcrumbActive = 'Loading Booking';
  TitleBox = 'Create Booking';

  Accounts: any[] = [];

  constructor(private dtService: DataService) { }
  ngOnInit(): void {
    this.setAccounts();
  }
  setAccounts(): void {
    this.dtService.getJSON("../../../../assets/mock-data/account.json")
      .subscribe(
      data => this.Accounts = data.Account,
      error => console.log(error),
      // () => console.log("Finished Call Accounts") 
    );
  }
}


// WEBPACK FOOTER //
// ./src/app/views/pages/transaction/op/outbound/booking/create-booking/create.component.ts